import * as yup from 'yup';
import { AuditorDateRangesPreferences } from '../../../data-models/preferences-v3.data-model';

export function auditorDateRangesConfigSchema() {
  return yup.object({
    startDate: yup
      .string()
      .required('Start date is required')
      .matches(/^\d{4}-\d{2}-\d{2}$/, 'Must be in format YYYY-MM-DD (e.g., 2024-01-01)'),
    endDate: yup
      .string()
      .required('End date is required')
      .matches(/^\d{4}-\d{2}-\d{2}$/, 'Must be in format YYYY-MM-DD (e.g., 2025-12-31)'),
    defaultFrequency: yup
      .string()
      .oneOf(['quarter', 'month', 'year'], 'Must be quarter, month, or year')
      .required(),
    restrictToRange: yup.boolean().required('Restrict to range is required'),
  });
}

export function getDefaultAuditorConfig(): AuditorDateRangesPreferences {
  return {
    startDate: '2024-01-01',
    endDate: '2025-12-31',
    defaultFrequency: 'quarter',
    restrictToRange: true,
  };
}
